// unifies a all of the values of one property of a list of objects
// to their distinct values
//
// let's say you have this array of objects
//
// let listOfObjects = [
//   {type: 1, color: 'red', shape: 'rect'},
//   {type: 1, color: 'blue', shape: 'circle'}, 
//   {type: 1, color: 'blue', 'polygon'}
// ]
//
// and you want to get the distinct values for the property "color"
// you call the function on the list of objects
// and get an array of unique value
//
// let distinctColors = getUnique(listOfObjetcs, 'color')
//
// yields
//
// => ['blue', 'red']

export function getUnique (arrayOfObjects, key) {
  return [...new Set(arrayOfObjects.map(o => String(o[key])))]
}

export default { getUnique }